exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".ButtonGroup .Button {\n  border-radius: 0; }\n\n.ButtonGroup.mod-Vertical .Button-innerShadow {\n  display: none; }\n\n.ButtonGroup.mod-Vertical .Button:not(:last-child) {\n  border-bottom-width: 0; }\n\n.ButtonGroup.mod-Vertical .Button:first-child {\n  border-radius: 3px 3px 0 0; }\n\n.ButtonGroup.mod-Vertical .Button:last-child {\n  border-radius: 0 0 3px 3px; }\n", ""]);

// exports
